<template>
  <v-tooltip :key="disabled" top :disabled="disabled">
    <template #activator="{ on }">
      <v-icon
        :color="disabled ? 'secondary' : color"
        :size="size"
        :class="iconClass"
        class="cursor-default"
        v-on="on"
        v-text="icon"
      />
    </template>

    <slot>
      <div
        :class="$vnode.data.staticClass"
        style="max-width: 400px;"
        v-html="text"
      />
    </slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BInfo',
  props: {
    disabled: Boolean,
    color: String,
    size: {
      type: String,
      default: '24px',
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
    iconClass: [String, Array, Object],
    text: {
      type: String,
    },
  },
}
</script>
